import { render } from "./question.vue?vue&type=template&id=100327aa&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"

import "./question.vue?vue&type=style&index=0&id=100327aa&scoped=true&lang=css"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100327aa"]])

export default __exports__